import Spin from 'components/Spin';
import React from 'react';
import { useObservable } from 'react-use-observable';
import QuickView from 'v2/components/Shared/QuickView';
import shoppingSubscriptionService from 'v2/services/shopping/subscription';

import SubscriptionActions from './actions';
import SubscriptionDetails from './details';
import SubscriptionHistory from './history';
import ProducerContact from './producerContact';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const SubscriptionQuickview = ({ open, onClose }: IProps) => {
  const [shopping] = useObservable(() => shoppingSubscriptionService.getCurrent(), []);

  return (
    <QuickView title={`Assinatura (${shopping?.product.id})`} open={open} onClose={onClose}>
      {shopping ? (
        <div className='quickviewBody'>
          <SubscriptionDetails />
          {shopping?.producer.showProducerContactInformation && (
            <>
              <div className='m24'></div>
              <ProducerContact shopping={shopping} />
            </>
          )}
          <div className={shopping?.producer.showProducerContactInformation ? 'm8' : 'm24'}></div>
          <SubscriptionHistory />
          <div className='m24'></div>
          <SubscriptionActions onClose={onClose} />
        </div>
      ) : (
        <Spin />
      )}
    </QuickView>
  );
};

export default SubscriptionQuickview;
